{
  "LOGIN": "Iniciar Sesión",
  "EMAIL": "Correo Electrónico",
  "EMAIL_PLACEHOLDER": "ejemplo@correo.com",
  "PASSWORD": "Contraseña",
  "PASSWORD_PLACEHOLDER": "••••••••",
  "PASSWORD_REQUIRED": "Por favor, introduce tu contraseña.",
  "VALIDATION_REQUIRED": "Este campo es obligatorio.",
  "VALIDATION_INVALID_EMAIL": "Por favor, introduce un correo electrónico válido.",
  "VALIDATION_MIN_LENGTH": "Debe tener al menos {{count}} caracteres.",
  "VALIDATION_MAX_LENGTH": "Debe tener como máximo {{count}} caracteres.",
  "VALIDATION_INVALID_URL": "URL inválida.",
  "SOURCE_URL_PLACEHOLDER": "ej: facebook.com/publicacion",
  "POST_SOURCE_PREFIX": "Fuente:",
  "POST_SOURCE_LINK_A11Y": "Fuente {{hostname}}: {{snippet}}",
  "SOURCE_MODAL_TITLE": "Fuente",
  "SOURCE_MODAL_HELPER": "Pega el enlace a la noticia o publicación original.",
  "SOURCE_URL_REMOVE": "Quitar",
  "SOURCE_URL_DOMAIN_NOT_ALLOWED": "Este dominio no está permitido como fuente.",
  "ADD_SOURCE": "Agregar fuente",
  "FORGOT_PASSWORD": "¿Olvidaste tu contraseña?",
  "OR": "O",
  "DONT_HAVE_ACCOUNT": "¿No tienes una cuenta?",
  "SIGN_UP": "Regístrate",
  "ERROR": "Error",
  "PLEASE_ENTER_EMAIL": "Por favor, introduce tu correo electrónico.",
  "SUCCESS": "Éxito",
  "IF_ACCOUNT_EXISTS": "Si existe una cuenta con ese correo electrónico, hemos enviado instrucciones para restablecer tu contraseña.",
  "SENDING": "Enviando...",
  "RESET_PASSWORD": "Restablecer Contraseña",
  "VERIFICATION_SENT": "Verificación Enviada",
  "VERIFICATION_EMAIL_SENT": "Se ha enviado un correo de verificación a tu bandeja de entrada. Si no lo encuentras, revisa la carpeta de spam o correo no deseado para continuar.",
  "ACCOUNT_EXISTS": "La Cuenta Ya Existe",
  "ACCOUNT_EXISTS_MESSAGE": "Ya existe una cuenta con este correo electrónico. Por favor, inicia sesión con tu método existente o vincula tu cuenta de Google desde la configuración de tu perfil.",
  "GOOGLE_SIGNIN_FAILED": "Error en el inicio de sesión con Google",
  "ALREADY_HAVE_ACCOUNT": "¿Ya tienes una cuenta?",
  "NO_POSTS_FOUND": "No se encontraron publicaciones.",
  "PLEASE_LOGIN_TO_INTERACT": "Inicia sesión para unirte a grupos y crear publicaciones.",
  "PLEASE_LOGIN_TO_REPORT": "Por favor, inicia sesión para denunciar.",
  "PLEASE_LOGIN_TO_SEE_COMMENTS": "Inicia sesión para ver y añadir comentarios.",
  "THANK_YOU_FOR_YOUR_FEEDBACK": "Gracias por tus comentarios.",
  "COULD_NOT_SUBMIT_REPORT": "No se pudo enviar la denuncia. Por favor, inténtalo de nuevo.",
  "DELETE_POST": "Eliminar Publicación",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_POST": "¿Estás seguro de que quieres eliminar esta publicación?",
  "CANCEL": "Cancelar",
  "CANCEL_INVITATION": "Cancelar",
  "CLOSE": "Cerrar",
  "DELETE": "Eliminar",
  "COULD_NOT_DELETE_POST": "No se pudo eliminar la publicación. Por favor, inténtalo de nuevo.",
  "SHARE": "Compartir",
  "COPY_LINK": "Copiar enlace",
  "LINK_COPIED": "Enlace copiado al portapapeles.",
  "COULD_NOT_SHARE": "No se pudo compartir. Por favor, inténtalo de nuevo.",
  "COULD_NOT_POST_COMMENT": "No se pudo publicar el comentario. Por favor, inténtalo de nuevo.",
  "DELETE_COMMENT": "Eliminar comentario",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COMMENT": "¿Estás seguro de que quieres eliminar este comentario?",
  "COULD_NOT_DELETE_COMMENT": "No se pudo eliminar el comentario. Por favor, inténtalo de nuevo.",
  "SHOW_LESS": "Mostrar menos",
  "READ_MORE": "Leer más",
  "PLATES": "Matrículas",
  "SPAM": "Spam",
  "INAPPROPRIATE_CONTENT": "Contenido Inapropiado",
  "HARASSMENT": "Acoso",
  "HATE_SPEECH": "Discurso de Odio",
  "OTHER": "Otro",
  "REPORT_POST": "Denunciar Publicación",
  "JUST_NOW": "Justo ahora",
  "YEAR_ABBREVIATION": "a",
  "MONTH_ABBREVIATION": "m",
  "DAY_ABBREVIATION": "d",
  "HOUR_ABBREVIATION": "h",
  "MINUTE_ABBREVIATION": "min",
  "LOCATION_PERMISSION_DENIED": "Permiso de ubicación denegado.",
  "LOCATION_UNAVAILABLE": "No pudimos obtener tu ubicación actual. Selecciónala manualmente en el mapa.",
  "NO_LOCATION": "Sin ubicación",
  "POST": "Publicar",
  "PUBLIC": "Público",
  "NOTIFICATION": "Notificación",
  "GLOBAL_FEED": "Feed global",
  "ACCIDENT": "Accidente",
  "ROBBERY": "Robo",
  "LAW_INFRACTION": "Infracción de Ley",
  "DESCRIPTION_PLACEHOLDER": "Descripción",
  "VEHICLE_PLATES_TITLE": "Matrículas de Vehículos",
  "VEHICLE_PLATES_PLACEHOLDER": "AAA123",
  "CLOSE_MAP": "Cerrar Mapa",
  "GROUP_LOCATION": "Ubicación del grupo",
  "GROUP_LOCATION_OPTIONAL": "Ubicación del grupo (opcional)",
  "ADD_LOCATION": "Agregar ubicación",
  "EDIT_LOCATION": "Editar ubicación",
  "REMOVE_LOCATION": "Quitar ubicación",
  "MY_LOCATION": "Mi ubicación",
  "ALLOW_MEMBER_LOCATION_OVERRIDE": "Permitir a los miembros usar una ubicación diferente en sus publicaciones",
  "LOCATION_LOCKED_BY_GROUP": "Ubicación fijada por el administrador del grupo",
  "LOCATION_FIXED": "Ubicación fija",
  "FAILED_TO_UPDATE_GROUP": "No se pudo actualizar el grupo. Inténtalo de nuevo.",
  "GROUP_UPDATED_SUCCESSFULLY": "Grupo actualizado correctamente",
  "PUBLIC_GROUP": "Grupo público",
  "PUBLIC_GROUP_HELP": "Cualquier persona con cuenta puede ver las publicaciones. Solo los miembros pueden publicar.",
  "PERMANENTLY_PRIVATE_HINT": "Este grupo es privado permanentemente y no puede volverse público.",
  "MAKE_GROUP_PRIVATE_TITLE": "¿Hacer este grupo privado?",
  "MAKE_GROUP_PRIVATE_BODY": "Una vez que hagas privado este grupo, no podrá volverse público. Los no miembros perderán el acceso a las publicaciones y comentarios.",
  "MAKE_PRIVATE": "Hacer privado",
  "SEARCH_PLACE_PLACEHOLDER": "Buscar un lugar",
  "MAP_FEATURES_UNAVAILABLE": "Algunas funciones del mapa no están disponibles",
  "PLACE_SELECTION_ERROR": "No se pudo cargar ese lugar",
  "SUBMIT_POST": "Enviar",
  "DONE": "Hecho",
  "MAXIMUM_NUMBER_OF_PLATES_REACHED": "Se ha alcanzado el número máximo de matrículas.",
  "PROFILE": "Perfil",
  "SETTINGS": "Ajustes",
  "APP_VERSION": "Versión {{version}} ({{buildSha}})",
  "LOGOUT": "Cerrar Sesión",
  "FAILED_TO_UPLOAD_IMAGE": "Error al subir la imagen.",
  "FAILED_TO_LOAD_MEDIA": "No se pudo cargar este archivo.",
  "TAP_TO_RETRY": "Toca para reintentar",
  "PLAY_VIDEO": "Reproducir video",
  "PAUSE_VIDEO": "Pausar video",
  "MUTE_VIDEO": "Silenciar",
  "UNMUTE_VIDEO": "Activar sonido",
  "VIEW_MEDIA": "Ver contenido",
  "LIKE": "Me gusta",
  "UNLIKE": "Ya no me gusta",
  "COMMENTS": "Comentarios",
  "MORE_OPTIONS": "Más opciones",
  "CONFIRM_FULL_NAME_AND_DATE_OF_BIRTH": "Confirmar Nombre Completo",
  "CONFIRM_FULL_NAME_MESSAGE": "¿Estás seguro de que quieres establecer tu nombre completo? No se podrá modificar más tarde.",
  "FULL_NAME_SET": "Nombre Completo Establecido",
  "FULL_NAME_MESSAGE_SET": "Tu nombre completo ha sido establecido con éxito.",
  "CONFIRM_DATE_OF_BIRTH": "Confirmar Fecha de Nacimiento",
  "CONFIRM_DATE_OF_BIRTH_MESSAGE": "¿Estás seguro de que quieres establecer tu fecha de nacimiento? No se podrá modificar más tarde.",
  "DATE_OF_BIRTH_SET": "Fecha de Nacimiento Establecida",
  "DATE_OF_BIRTH_MESSAGE_SET": "Tu fecha de nacimiento ha sido establecida con éxito.",
  "SAVE_DATE_OF_BIRTH": "Guardar Fecha de Nacimiento",
  "PLEASE_SELECT_DATE_OF_BIRTH": "Por favor, selecciona tu fecha de nacimiento.",
  "USERNAME_CANNOT_CONTAIN_SPACES": "El nombre de usuario no puede contener espacios.",
  "PLEASE_ENTER_VALID_DATE": "Por favor, introduce una fecha válida en formato DD/MM/AAAA.",
  "PROFILE_UPDATED": "Perfil Actualizado",
  "YOUR_PROFILE_HAS_BEEN_UPDATED_SUCCESSFULLY": "Tu perfil ha sido actualizado con éxito.",
  "FAILED_TO_UPDATE_PROFILE": "Error al actualizar el perfil.",
  "FOLLOWERS": "Seguidores",
  "FOLLOWING": "Siguiendo",
  "FIRST_NAME": "Nombre",
  "LAST_NAME": "Apellido",
  "PHONE_NUMBER": "Número de Teléfono",
  "CROP_PROFILE_PICTURE": "Ajustar tu foto",
  "PLEASE_ENTER_VALID_PHONE_NUMBER": "Por favor, introduce un número de teléfono válido.",
  "DATE_OF_BIRTH": "Fecha de Nacimiento",
  "COUNTRY": "País",
  "SELECT_COUNTRY": "Selecciona un país",
  "CODE": "Cód.",
  "BIO": "Biografía",
  "PLEASE_ENTER_FIRST_NAME": "Por favor, introduce tu nombre.",
  "PLEASE_ENTER_LAST_NAME": "Por favor, introduce tu apellido.",
  "SAVE_PERSONAL_DATA": "Guardar Datos Personales",
  "USERNAME": "Nombre de Usuario",
  "DATE_PLACEHOLDER": "DD/MM/AAAA",
  "UPDATE_PROFILE": "Actualizar Perfil",
  "SETTINGS_SAVED": "Configuración guardada",
  "FOLLOWED_PLATES": "Matrículas Seguidas",
  "WA_POST_NOTIFICATIONS": "WhatsApp",
  "WA_POST_NOTIFICATIONS_HINT": "Recibir notificaciones por WhatsApp.",
  "WA_NOTIFICATIONS_MORE_DETAILS": "Más detalles",
  "WA_NOTIFICATIONS_FREE_PLAN_NOTICE": "Plan gratuito: 1 notificación de WhatsApp por mes. Sujeto a tiempo limitado y disponibilidad.",
  "WA_NOTIFICATIONS_VERIFY_PHONE_HINT": "Verifica tu número de teléfono para recibir mensajes de WhatsApp.",
  "WA_NOTIFICATIONS_VERIFY_PHONE_CTA": "Verificar teléfono",
  "WA_NOTIFICATIONS_LEFT_THIS_MONTH": "Notificaciones restantes este mes",
  "WA_NOTIFICATIONS_LAST_RECEIVED": "Último recibido",
  "WA_NOTIFICATIONS_RENEWS_ON": "Se renueva el",
  "WA_NOTIFICATIONS_NEVER": "-",
  "WA_RECONSENT_NOTICE": "Los términos de nuestras notificaciones por WhatsApp han sido actualizados. Revísalos y acéptalos para seguir recibiendo mensajes.",
  "WA_RECONSENT_CTA": "Revisar",
  "WA_ENABLE_CONFIRM_TITLE": "¿Activar las notificaciones por WhatsApp?",
  "WA_ENABLE_CONFIRM_BODY": "Para enviarte notificaciones, compartiremos tu número de teléfono con WhatsApp (Meta), que entregará un mensaje corto con un enlace a VehiLink cada vez que un reporte mencione una matrícula que sigues. El mensaje en sí no incluye la matrícula, la ubicación ni los detalles del evento — esos se muestran cuando abres el enlace. Puedes desactivarlas en cualquier momento desde esta pantalla.",
  "WA_ENABLE_CONFIRM_CTA": "Activar",
  "GLOBAL_FEED_NOTIFICATIONS": "Feed global",
  "GLOBAL_FEED_NOTIFICATIONS_HINT": "Recibe notificaciones publicadas en el Feed global.",
  "ON": "Activado",
  "OFF": "Desactivado",
  "SAVE": "Guardar",
  "LIKED_YOUR_POST": "Le ha gustado tu publicación.",
  "COMMENTED_ON_YOUR_POST": "Ha comentado en tu publicación.",
  "COMMENTED_ON_POST_YOU_COMMENTED_ON": "También comentó en una publicación que comentaste.",
  "STARTED_FOLLOWING_YOU": "Ha comenzado a seguirte.",
  "CREATED_A_NEW_POST": "Ha creado una nueva publicación.",
  "PUBLISHED_A_NOTIFICATION": "Ha publicado una notificación.",
  "NO_NOTIFICATIONS": "No tienes notificaciones.",
  "DUPLICATE_PLATE": "Matrícula Duplicada",
  "VEHICLE_PLATE_ALREADY_ADDED": "Esta matrícula de vehículo ya ha sido añadida.",
  "INVALID_PLATE_FORMAT": "Formato de chapa inválido",
  "INVALID_PLATE_FORMAT_HINT": "Matrícula inválida para {{country}}.",
  "TYPE_LABEL": "Tipo:",
  "GROUP_POST_RECIPIENT_LABEL": "Para:",
  "GROUP_POST_PLATES_OPTIONAL": "Chapas (opcional)",
  "GROUP_POST_EVENT_DATE": "Fecha del evento",
  "MEDIA_LIMIT_REACHED": "Límite de Medios Alcanzado",
  "MEDIA_LIMIT_REACHED_MESSAGE": "Solo puedes subir hasta {{count}} archivos.",
  "VIDEO_LIMIT_REACHED": "Límite de Videos Alcanzado",
  "VIDEO_LIMIT_REACHED_MESSAGE": "Solo puedes subir hasta {{count}} video. Todavía puedes añadir imágenes.",
  "VIDEO_SIZE_LIMIT_REACHED": "Límite de Tamaño de Video Alcanzado",
  "VIDEO_SIZE_LIMIT_REACHED_MESSAGE": "Los videos deben ser más pequeños de {{count}}MB.",
  "VIDEO_TOO_LARGE_MESSAGE": "Este video pesa {{size}} MB — supera el límite de {{count}} MB. Intenta recortarlo o grabarlo en menor resolución antes de subirlo.",
  "IMAGE_INPUT_SIZE_LIMIT_REACHED": "Foto demasiado grande",
  "IMAGE_INPUT_SIZE_LIMIT_MESSAGE": "No se pueden subir fotos de más de {{count}} MB. Elige un archivo más pequeño — nosotros optimizaremos las demás.",
  "OPTIMIZING_IMAGES": "Optimizando imágenes…",
  "FILES_NOT_ADDED_WARNING": "Este archivo no se pudo añadir.",
  "YOUR_POST_HAS_BEEN_SUCCESSFULLY_SUBMITTED": "Tu publicación ha sido enviada con éxito.",
  "FAILED_TO_SUBMIT_POST": "Error al enviar la publicación. Por favor, inténtalo de nuevo.",
  "CONFIRM_SUBMISSION": "Confirmar Envío",
  "ARE_YOU_SURE_YOU_WANT_TO_SUBMIT_THIS_POST": "¿Estás seguro de que quieres enviar esta publicación? No se podrá editar más tarde.",
  "SUBMIT": "Enviar",
  "PLATE_FOLLOWERS_ONLY": "Solo seguidores de matrícula",
  "POST_ANONYMOUSLY": "Publicar anónimamente",
  "POST_ANONYMOUSLY_HELP": "Tu nombre quedará oculto para otros usuarios. VehiLink todavía puede identificarte si una publicación infringe nuestros términos.",
  "CREATE_GROUP": "Crear Grupo",
  "GROUP_DETAILS": "Detalles del Grupo",
  "GROUPS": "Grupos",
  "GROUP_NAME_REQUIRED": "El nombre del grupo es obligatorio.",
  "GROUP_CREATED_SUCCESSFULLY": "Grupo creado con éxito.",
  "FAILED_TO_CREATE_GROUP": "Error al crear el grupo.",
  "GROUP_NAME": "Nombre del Grupo",
  "ENTER_GROUP_NAME": "Introduce el nombre del grupo",
  "DESCRIPTION": "Descripción",
  "ENTER_GROUP_DESCRIPTION": "Introduce la descripción del grupo",
  "REPORT": "Denunciar",
  "NO_POSTS_IN_GROUP": "Aún no hay publicaciones en este grupo.",
  "INVITATIONS": "Invitaciones",
  "NO_GROUPS_FOUND": "Aún no eres parte de ningún grupo.",
  "CREATE_A_NEW_ONE": "¡Crea uno nuevo!",
  "REMOVE": "Eliminar",
  "REMOVE_MEMBER": "Eliminar Miembro",
  "ARE_YOU_SURE_YOU_WANT_TO_REMOVE_MEMBER": "¿Estás seguro de que quieres eliminar a este miembro del grupo?",
  "COULD_NOT_REMOVE_MEMBER": "No se pudo eliminar a este miembro. Por favor, inténtalo de nuevo.",
  "COULD_NOT_LEAVE_GROUP": "No se pudo salir del grupo. Por favor, inténtalo de nuevo.",
  "COULD_NOT_CANCEL_INVITATION": "No se pudo cancelar la invitación. Por favor, inténtalo de nuevo.",
  "PROMOTE_TO_ADMIN": "Promover a Administrador",
  "INVITE_USERS": "Invitar Usuarios",
  "INVITE_USER_TO": "Invitar a {{groupName}}",
  "INVITE_BY_EMAIL": "Correo",
  "INVITE_BY_USERNAME": "Usuario",
  "INVITE_BY_PHONE": "Teléfono",
  "ENTER_USER_EMAIL": "Introduce el correo del usuario",
  "ENTER_USERNAME": "Introduce el nombre de usuario",
  "PLEASE_ENTER_USERNAME": "Por favor introduce un nombre de usuario",
  "PLEASE_ENTER_PHONE": "Por favor introduce un número de teléfono",
  "PLEASE_SELECT_COUNTRY": "Por favor selecciona un país",
  "CANNOT_INVITE_YOURSELF": "No puedes invitarte a ti mismo.",
  "USER_ALREADY_MEMBER": "Este usuario ya es miembro del grupo.",
  "PENDING_INVITE": "Invitación pendiente",
  "INVITE_USER": "Invitar Usuario",
  "USER_NOT_FOUND": "Usuario no encontrado",
  "INVITATION_SENT_SUCCESSFULLY": "¡Invitación enviada con éxito!",
  "FAILED_TO_SEND_INVITATION": "Error al enviar la invitación.",
  "INVITATION_ACCEPT_FAILED": "No pudimos aceptar la invitación. Inténtalo de nuevo.",
  "INVITATION_DECLINE_FAILED": "No pudimos rechazar la invitación. Inténtalo de nuevo.",
  "INVITED_YOU_TO_GROUP": "te invitó a {{groupName}}.",
  "ACCEPTED": "Aceptada",
  "POSTED_IN_GROUP": "Publicó en {{groupName}}.",
  "ACCEPT": "Aceptar",
  "DECLINE": "Rechazar",
  "NOTIFICATIONS": "Notificaciones",
  "UPLOADING_POST": "Subiendo publicación...",
  "UPLOADING_POST_DONT_CLOSE": "Por favor no cierres la app todavía",
  "POST_UPLOADED_SUCCESSFULLY": "¡Publicación subida con éxito!",
  "EDIT": "Editar",
  "EDIT_POST": "Editar publicación",
  "CONFIRM_SAVE_EDIT": "¿Guardar los cambios de esta publicación?",
  "POST_SAVED_SUCCESSFULLY": "Cambios guardados",
  "FAILED_TO_SAVE_POST": "No se pudieron guardar los cambios. Inténtalo de nuevo.",
  "SAVING_POST": "Guardando...",
  "OPTIONAL": "Opcional",
  "ADD_A_COMMENT": "Añade un comentario...",
  "NO_COMMENTS_YET": "Aún no hay comentarios.",
  "POST_NOT_FOUND": "Publicación no encontrada.",
  "PHONE_PLACEHOLDER": "Introduce tu número de teléfono",
  "VERIFY": "Verificar",
  "ENTER_VERIFICATION_CODE": "Código de verificación",
  "VERIFYING_CODE": "Verificando código...",
  "VERIFICATION_CODE_SENT": "¡Código de verificación enviado!",
  "FAILED_TO_SEND_VERIFICATION_CODE": "Error al enviar el código de verificación.",
  "VERIFICATION_FAILED": "La verificación ha fallado.",
  "INVALID_VERIFICATION_CODE": "Código inválido. Verifícalo e inténtalo de nuevo.",
  "CODE_EXPIRED_REQUEST_NEW": "El código expiró. Cierra esta ventana y solicita uno nuevo.",
  "PHONE_ALREADY_IN_USE": "Este número de teléfono ya está vinculado a otra cuenta.",
  "ADD_MEDIA_TITLE": "Añadir Medios",
  "ADD_MEDIA_MESSAGE": "Elige una fuente para tus medios",
  "TAKE_PHOTO": "Cámara",
  "CHOOSE_FROM_LIBRARY": "Galería",
  "CAMERA_PERMISSION_TITLE": "Se Requiere Permiso de Cámara",
  "CAMERA_PERMISSION_MESSAGE": "Necesitas conceder permiso a la cámara para usarla.",
  "SENT_YOU_A_NOTIFICATION": "te ha enviado una notificación.",
  "POSTS": "Publicaciones",
  "NO_POSTS_YET": "Este usuario aún no tiene publicaciones.",
  "JOINED": "Se unió en {{date}}",
  "EDIT_PROFILE": "Editar Perfil",
  "LEAVE_GROUP": "Salir del Grupo",
  "ARE_YOU_SURE_YOU_WANT_TO_LEAVE_GROUP": "¿Estás seguro de que quieres salir de este grupo?",
  "TERMS_AND_CONDITIONS": "Términos y Condiciones",
  "PRIVACY_POLICY": "Política de Privacidad",
  "AND": "y",
  "BY_SIGNING_UP_AGREE": "Al registrarte, aceptas nuestros",
  "BY_CONTINUING_AGREE": "Al continuar, aceptas nuestros",
  "NO_ACCOUNT_FOUND": "Cuenta no encontrada",
  "NO_ACCOUNT_FOUND_MESSAGE": "Regístrate primero antes de iniciar sesión.",
  "FAILED_TO_SEND_CODE": "No se pudo enviar el código. Por favor, inténtalo de nuevo.",
  "ARE_YOU_SURE_YOU_WANT_TO_LOGOUT": "¿Estás seguro de que quieres cerrar sesión?",
  "POST_DETAILS": "Publicación",
  "POSTED": "Publicado",
  "RECEIVED": "Recibido",
  "NO_RECEIVED_POSTS_YET": "Este usuario aún no tiene publicaciones recibidas.",
  "HELP": "Ayuda",
  "HELP_DESCRIPTION": "Para cualquier consulta, contáctanos por los canales de abajo.",
  "HELP_CONTACT_TITLE": "Contacto",
  "HELP_FOLLOW_TITLE": "Síguenos",
  "HELP_EMAIL_LABEL": "Correo",
  "HELP_WHATSAPP_LABEL": "WhatsApp",
  "HELP_INSTAGRAM_LABEL": "Instagram",
  "HELP_X_LABEL": "X",
  "HELP_FACEBOOK_LABEL": "Facebook",
  "SIGN_UP_ERROR": "Error de registro",
  "LOGIN_ERROR": "Error de inicio de sesión",
  "GOOGLE_SIGN_IN_ERROR": "Error al iniciar sesión con Google",
  "GOOGLE_SIGN_IN_FAILED_NO_TOKEN": "El inicio de sesión con Google falló: no se devolvió idToken o correo electrónico.",
  "RESEND": "Reenviar",
  "RESEND_IN_SECONDS": "Reenviar en {{seconds}} s",
  "SIGN_UP_ERROR_MESSAGE": "Error de registro",
  "SIGN_IN_WITH_GOOGLE": "Iniciar sesión con Google",
  "GOOGLE_SIGN_IN_SHORT": "Google",
  "INVALID_CREDENTIALS": "Correo electrónico o contraseña inválidos.",
  "VERIFIED_USER": "Usuario verificado",
  "EMAIL_NOT_VERIFIED": "Correo Electrónico No Verificado",
  "EMAIL_NOT_VERIFIED_RESEND_PROMPT": "Tu correo electrónico aún no está verificado. Es posible que el enlace haya expirado o haya llegado a tu carpeta de spam o correo no deseado. ¿Quieres que enviemos otro?",
  "RESEND_TOO_MANY_REQUESTS": "Demasiadas solicitudes. Por favor, espera un momento antes de intentarlo de nuevo.",
  "NETWORK_ERROR": "Error de red. Por favor, verifica tu conexión a internet e inténtalo de nuevo.",
  "TOO_MANY_LOGIN_ATTEMPTS": "Demasiados intentos fallidos de inicio de sesión. Por favor, espera un momento antes de intentarlo de nuevo.",
  "ACCOUNT_DISABLED": "Esta cuenta ha sido deshabilitada. Por favor, contacta con soporte.",
  "UNEXPECTED_ERROR": "Algo salió mal. Por favor, inténtalo de nuevo.",
  "OPTIONAL_DETAILS": "Detalles (opcional)",
  "SUBMIT_REPORT": "Enviar Denuncia",
  "OK": "OK",
  "YES": "Sí",
  "CONFIRM_POST": "Confirmar Publicación",
  "CONFIRM": "Confirmar",
  "USERNAME_TOO_SHORT": "El nombre de usuario debe tener al menos 3 caracteres.",
  "USERNAME_INVALID_CHARACTERS": "El nombre de usuario solo puede contener letras, números, guiones bajos y puntos.",
  "USERNAME_INVALID_START": "El nombre de usuario debe comenzar con una letra o un número.",
  "USERNAME_REQUIRED": "El nombre de usuario es obligatorio.",
  "USERNAME_ALREADY_TAKEN": "Este nombre de usuario ya está en uso.",
  "CHECKING_USERNAME_AVAILABILITY": "Comprobando disponibilidad del nombre de usuario...",
  "USER_ALREADY_INVITED": "Este usuario ya ha sido invitado al grupo.",
  "PENDING": "Pendiente",
  "JOIN": "Unirse",
  "install-app": "Instalar App",
  "install-app-title": "Instalar VehiLink App",
  "install-app-description": "Instala nuestra aplicación en tu dispositivo para una mejor experiencia.",
  "install-app-ios-step1": "Toca el menú de tres puntos (•••) en Safari",
  "install-app-ios-step2-prefix": "Luego toca",
  "install-app-ios-share-label": "Compartir",
  "install-app-ios-step3-prefix": "Selecciona",
  "install-app-ios-step3-target": "Añadir a pantalla de inicio",
  "install-app-ios-open-in-safari": "Abre esta página en Safari para instalar la app de VehiLink en tu iPhone o iPad.",
  "dismiss": "Descartar",
  "ONBOARDING_OPTIONAL": "opcional",
  "ONBOARDING_REQUIRED": "obligatorio",
  "ONBOARDING_STEP_FULL_NAME": "Nombre completo",
  "ONBOARDING_FULL_NAME_LABEL": "Nombre completo",
  "ONBOARDING_FULL_NAME_PLACEHOLDER": "Ingresa tu nombre completo",
  "ONBOARDING_USERNAME_PLACEHOLDER": "Elige un nombre de usuario",
  "ONBOARDING_AGE_CONFIRMATION_LABEL": "Confirmo que tengo 13 años o más.",
  "ONBOARDING_PHONE_PLACEHOLDER": "Tu número de teléfono",
  "ONBOARDING_PLATE_LABEL": "Seguir una matrícula",
  "ONBOARDING_PLATE_HINT": "Agrega una matrícula para recibir alertas relacionadas con esa matrícula.",
  "ONBOARDING_PLATE_ENTER_HINT": "Ingresa tu matrícula y presiona Enter",
  "ONBOARDING_SHOW_ME": "Continuar",
  "ONBOARDING_DONT_SHOW_PLATE_AGAIN": "No volver a mostrar esto",
  "ONBOARDING_ADD_PLATE": "Agregar matrícula",
  "ONBOARDING_SELECTED_PLATE_PREFIX": "Seleccionada:",
  "ONBOARDING_NO_PLATE_SELECTED": "No hay matrícula seleccionada",
  "ONBOARDING_SKIP": "Omitir",
  "ONBOARDING_BACK": "Atrás",
  "ONBOARDING_CONTINUE": "Continuar",
  "ONBOARDING_FINISH": "Finalizar",
  "ONBOARDING_PLATE_MODAL_TITLE": "Seguir matrícula",
  "ONBOARDING_PLATE_PENDING_CONFIRM_TITLE": "Confirmar matrícula",
  "ONBOARDING_PLATE_PENDING_CONFIRM_MESSAGE": "¿Quieres seguir esta matrícula antes de continuar?",
  "ONBOARDING_VALIDATION_ERROR_TITLE": "Error de validación",
  "ONBOARDING_ERROR_FULL_NAME_REQUIRED": "Por favor, ingresa tu nombre completo.",
  "ONBOARDING_ERROR_USERNAME_REQUIRED": "Por favor, elige un nombre de usuario.",
  "ONBOARDING_ERROR_USERNAME_TOO_SHORT": "El nombre de usuario debe tener al menos 3 caracteres.",
  "ONBOARDING_ERROR_USERNAME_INVALID": "El nombre de usuario solo puede contener letras, números, guiones bajos y puntos.",
  "ONBOARDING_ERROR_USERNAME_TAKEN": "Este nombre de usuario ya está en uso. Elige otro.",
  "ONBOARDING_ERROR_AGE_CONFIRMATION_REQUIRED": "Por favor, confirma que tienes 13 años o más para continuar.",
  "ONBOARDING_ERROR_STEP_SAVE": "No se pudo guardar este paso. Inténtalo de nuevo.",
  "PLATE_GUIDE_PROMPT_TITLE": "Vamos a configurar tu matrícula",
  "PLATE_GUIDE_PROMPT_MESSAGE": "Sigue los pasos resaltados en Ajustes.",
  "NOT_NOW": "Ahora no",
  "PLATE_TOUR_STEP1_TITLE": "Paso 1: Abrir matrículas",
  "PLATE_TOUR_STEP1_MESSAGE": "Ve a Ajustes > Matrículas.",
  "PLATE_TOUR_STEP2_TITLE": "Paso 2: Agrega tu matrícula",
  "PLATE_TOUR_STEP2_MESSAGE": "Ingresa tu matrícula en este campo y luego guarda.",
  "PLATE_TOUR_STEP2_SAVE_HINT": "Ingresa tu matrícula y presiona Guardar para terminar la configuración.",
  "INFO": "Información",
  "GOT_IT": "Entendido",
  "SEARCH": "Buscar",
  "SEARCH_USERNAME_PLACEHOLDER": "Buscar por usuario o matrícula",
  "SEARCH_HINT": "Busca por usuario o matrícula, o aplica filtros para encontrar publicaciones.",
  "NO_RESULTS_FOUND": "No se encontraron resultados.",
  "FILTERS": "Filtros",
  "FILTER_PLATE": "Matrícula",
  "FILTER_EVENT_TYPE": "Tipo de evento",
  "FILTER_DATE_FIELD_CREATED": "Fecha de publicación",
  "FILTER_DATE_FIELD_EVENT": "Fecha del evento",
  "FILTER_DATE_RANGE": "Rango de fechas",
  "FILTER_DATE_FROM": "Desde",
  "FILTER_DATE_TO": "Hasta",
  "SEARCH_ERROR_INDEX": "No pudimos aplicar esta combinación de filtros en este momento. Prueba con menos filtros o inténtalo más tarde.",
  "SEARCH_ERROR_GENERIC": "No se pudo completar la búsqueda. Inténtalo de nuevo.",
  "ANY": "Cualquiera",
  "RESET": "Restablecer",
  "APPLY": "Aplicar",
  "HOME_TAB_FEED": "Noticias",
  "HOME_TAB_MAP": "Mapa",
  "MAP_FILTER_RECENCY": "Cuándo",
  "MAP_FILTER_CITY": "Ciudad",
  "MAP_FILTER_EVENT_TYPE": "Tipo",
  "MAP_ANY_EVENT_TYPE": "Cualquier tipo",
  "MAP_RECENCY_1H": "Última hora",
  "MAP_RECENCY_24H": "Últimas 24h",
  "MAP_RECENCY_7D": "Últimos 7 días",
  "MAP_RECENCY_30D": "Últimos 30 días",
  "MAP_ANY_CITY": "Cualquier ciudad",
  "MAP_NO_POSTS": "No hay publicaciones en este rango",
  "MAP_NO_POSTS_WITH_LOCATION": "No hay publicaciones con ubicación en este rango",
  "MAP_FETCHED_COUNT": "{{count}} publicación(es) cargada(s)",
  "MAP_LOADING": "Cargando mapa…",
  "MAP_ERROR": "No se pudo cargar el mapa.",
  "MAP_MARKER_ARIA": "Publicación",
  "NOT_A_MEMBER_OF_GROUP": "Aún no tienes acceso a {{groupName}}",
  "REQUEST_ACCESS": "Solicitar acceso",
  "REQUEST_UNDER_REVIEW": "Solicitud en revisión",
  "ACCESS_REQUEST_SENT": "Solicitud de acceso enviada",
  "FAILED_TO_REQUEST_ACCESS": "No se pudo enviar la solicitud. Intenta nuevamente.",
  "PENDING_REQUEST_LABEL": "SOLICITUD PENDIENTE",
  "APPROVE": "Aprobar",
  "APPROVED": "Aprobada",
  "DECLINED": "Rechazada",
  "USER": "Usuario",
  "MEMBERS": "Miembros",
  "COULD_NOT_APPROVE_REQUEST": "No se pudo aprobar la solicitud.",
  "COULD_NOT_DECLINE_REQUEST": "No se pudo rechazar la solicitud.",
  "REQUESTED_GROUP_ACCESS": "solicitó acceso a {{groupName}}",
  "GROUP_ACCESS_APPROVED_BODY": "Tu solicitud para unirte a {{groupName}} fue aprobada",
  "CHANGE_GROUP_IMAGE": "Cambiar imagen del grupo",
  "FAB_CREATE_POST": "Crear publicación",
  "FAB_REPORT_NEARBY": "Reporte cercano",
  "AREA_REPORT_TITLE": "Reporte del área",
  "AREA_REPORT_SCOPE_500M_30D": "En 500 m · últimos 30 días",
  "AREA_REPORT_LOADING": "Revisando tu zona…",
  "AREA_REPORT_LOCATION_DENIED": "Necesitamos tu ubicación para generar este reporte.",
  "AREA_REPORT_LOCATION_UNAVAILABLE": "No pudimos determinar tu ubicación. Por favor intenta de nuevo.",
  "AREA_REPORT_LOCATION_RETRY": "Reintentar",
  "AREA_REPORT_EMPTY": "Sin reportes cercanos en los últimos 30 días.",
  "AREA_REPORT_NEAREST_X_METERS": "Más cercano: {{meters}} m",
  "AREA_REPORT_COVERAGE_CAVEAT": "Sólo se cuentan publicaciones con ubicación precisa.",
  "AREA_REPORT_UNAVAILABLE_ON_PLATFORM": "Los reportes del área sólo están disponibles en web por ahora.",
  "AREA_REPORT_NO_DESCRIPTION": "(sin descripción)",
  "SIGN_UP_WITH_PHONE": "Registrarme con teléfono",
  "SIGN_IN_WITH_PHONE": "Iniciar sesión con teléfono",
  "PHONE_SIGNUP_SUBTITLE": "Te enviaremos un código de verificación por SMS.",
  "PHONE_SIGNIN_SUBTITLE": "Te enviaremos un código por SMS para iniciar sesión.",
  "PHONE_SIGNUP_SEND_CODE": "Enviar código",
  "PHONE_SIGNUP_CODE_SENT": "Enviamos un código a {{phone}}.",
  "PHONE_SIGNUP_ALREADY_REGISTERED": "Este teléfono ya está registrado. Intenta iniciar sesión.",
  "RECAPTCHA_DISCLOSURE_PREFIX": "Este sitio está protegido por reCAPTCHA y se aplican la ",
  "RECAPTCHA_DISCLOSURE_PRIVACY": "Política de Privacidad",
  "RECAPTCHA_DISCLOSURE_MIDDLE": " y los ",
  "RECAPTCHA_DISCLOSURE_TERMS": "Términos del Servicio",
  "RECAPTCHA_DISCLOSURE_SUFFIX": " de Google.",
  "ONBOARDING_PHONE_PLATE_TITLE": "Introduce tu número de chapa",
  "ONBOARDING_PHONE_PLATE_SUBTITLE": "Te avisaremos cuando haya novedades sobre esta matrícula. Podés cambiarla luego desde Ajustes.",
  "ONBOARDING_PHONE_PLATE_CTA": "Comenzar a recibir alertas",
  "ONBOARDING_ERROR_PLATE_REQUIRED": "Por favor agrega una matrícula para continuar.",
  "ANONYMOUS_USER": "Anónimo",
  "BACK": "Volver",
  "SIGN_IN_METHODS": "Métodos de inicio de sesión",
  "SIGN_IN_METHODS_SUBTITLE": "Administra cómo inicias sesión en VehiLink.",
  "DEFAULT_HOME": "Página de inicio",
  "DEFAULT_HOME_DESCRIPTION": "Elige qué pestaña se abre al iniciar VehiLink.",
  "DEFAULT_HOME_FEED": "Feed de noticias",
  "DEFAULT_HOME_FEED_DESCRIPTION": "Abre el Feed global cada vez que entres a la app.",
  "DEFAULT_HOME_GROUPS": "Grupos",
  "DEFAULT_HOME_GROUPS_DESCRIPTION": "Abre tu lista de Grupos cada vez que entres a la app.",
  "LINKED": "Vinculado",
  "NOT_LINKED": "No vinculado",
  "PRIMARY_PROVIDER_LABEL": "Principal",
  "LINK": "Vincular",
  "UNLINK": "Desvincular",
  "LINKING": "Vinculando...",
  "UNLINKING": "Desvinculando...",
  "GOOGLE": "Google",
  "LINK_GOOGLE_ACCOUNT": "Vincula tu cuenta de Google",
  "LINK_GOOGLE_DESCRIPTION": "Inicia sesión con Google además de tus otros métodos.",
  "GOOGLE_LINK_SUCCESS": "Cuenta de Google vinculada.",
  "GOOGLE_LINK_ERROR": "No se pudo vincular la cuenta de Google.",
  "LINK_EMAIL_PASSWORD": "Añadir correo y contraseña",
  "LINK_EMAIL_PASSWORD_DESCRIPTION": "Añade un correo y contraseña para que puedas iniciar sesión sin tu teléfono o Google.",
  "EMAIL_LINK_SUCCESS": "Inicio de sesión por correo añadido. Te enviamos un correo de verificación, por favor verifícalo para poder seguir iniciando sesión con tus otros métodos.",
  "LINK_ACCOUNT": "Vincular cuenta",
  "EMAIL_LINK_ERROR": "No se pudo añadir el inicio de sesión por correo.",
  "CONFIRM_PASSWORD": "Confirma la contraseña",
  "PASSWORDS_DO_NOT_MATCH": "Las contraseñas no coinciden.",
  "LINK_PHONE_TITLE": "Añadir teléfono",
  "LINK_PHONE_DESCRIPTION": "Te enviaremos un código de verificación. Después podrás iniciar sesión solo con tu teléfono.",
  "PHONE_LINK_SUCCESS": "Número de teléfono vinculado.",
  "PHONE_LINK_ERROR": "No se pudo vincular el teléfono.",
  "UNLINK_PROVIDER_TITLE": "¿Desvincular {{provider}}?",
  "UNLINK_PROVIDER_MESSAGE": "Ya no podrás iniciar sesión con {{provider}}. Otros métodos seguirán funcionando.",
  "UNLINK_ONLY_PROVIDER_HELPER": "Necesitas al menos un método de inicio de sesión.",
  "UNLINK_SUCCESS": "{{provider}} desvinculado.",
  "UNLINK_ERROR": "No se pudo desvincular {{provider}}.",
  "CREDENTIAL_ALREADY_IN_USE_TITLE": "Ya está en uso",
  "CREDENTIAL_ALREADY_IN_USE_MESSAGE": "Esta cuenta ya está vinculada a otro usuario de VehiLink. Inicia sesión en esa cuenta y vincula tus otros métodos desde ahí.",
  "PROVIDER_ALREADY_LINKED_MESSAGE": "Este método de inicio de sesión ya está vinculado a tu cuenta.",
  "REQUIRES_RECENT_LOGIN_TITLE": "Inicia sesión de nuevo",
  "REQUIRES_RECENT_LOGIN_MESSAGE": "Por seguridad, cierra sesión y vuelve a iniciar sesión antes de hacer este cambio.",
  "POPUP_BLOCKED_MESSAGE": "Ventana emergente bloqueada. Permite las ventanas emergentes de VehiLink e inténtalo de nuevo.",
  "PHONE_VERIFY_BANNER_MESSAGE": "Verifica tu número de teléfono para recibir notificaciones de WhatsApp.",
  "PHONE_VERIFY_BANNER_CTA": "Verificar",
  "PHONE_VERIFY_BANNER_CLOSE": "Cerrar",
  "DISCARD": "Descartar",
  "UNSAVED_CHANGES_TITLE": "Cambios sin guardar",
  "UNSAVED_CHANGES_MESSAGE": "Tienes cambios sin guardar. ¿Descartarlos?",
  "ERROR_LOADING_SETTINGS": "No se pudo cargar tu configuración. Inténtalo de nuevo.",
  "ERROR_SAVING_SETTINGS": "No se pudo guardar tu configuración. Inténtalo de nuevo.",
  "UNFOLLOW": "Remover",
  "UNFOLLOW_PLATE_TITLE": "Dejar de seguir matrícula",
  "ARE_YOU_SURE_YOU_WANT_TO_UNFOLLOW_PLATE": "¿Estás seguro de que quieres dejar de seguir esta matrícula?",
  "GO_TO_IMAGE_N": "Ir a la imagen {{n}}",
  "GO_TO_ITEM_N": "Ir al elemento {{n}}",
  "VEHILINK_LOGO_ALT": "Logotipo de VehiLink",
  "POST_IMAGE_ALT": "Imagen del reporte",
  "USER_AVATAR_ALT": "Foto de perfil",
  "GROUP_AVATAR_ALT": "Foto del grupo",
  "NAV_PRIMARY": "Navegación principal",
  "NAV_ACCOUNT": "Cuenta",
  "LANDING_H1": "Inicio",
  "PAGE_TITLE_FEED": "Inicio · VehiLink",
  "PAGE_TITLE_LOGIN": "Iniciar sesión · VehiLink",
  "PAGE_TITLE_SIGNUP": "Crear cuenta · VehiLink",
  "PAGE_TITLE_FORGOT_PASSWORD": "Recuperar contraseña · VehiLink",
  "PAGE_TITLE_ONBOARDING": "Bienvenido · VehiLink",
  "PAGE_TITLE_POST": "{{title}} · VehiLink",
  "PAGE_TITLE_GROUPS": "Grupos · VehiLink",
  "PAGE_TITLE_GROUP": "{{name}} · VehiLink",
  "PAGE_TITLE_GROUP_CREATE": "Crear grupo · VehiLink",
  "PAGE_TITLE_GROUP_INFO": "Detalles del grupo · VehiLink",
  "PAGE_TITLE_GROUP_INVITE": "Invitar al grupo · VehiLink",
  "PAGE_TITLE_SETTINGS": "Ajustes · VehiLink",
  "PAGE_TITLE_SETTINGS_NOTIFICATIONS": "Notificaciones · Ajustes · VehiLink",
  "PAGE_TITLE_SETTINGS_PLATES": "Matrículas · Ajustes · VehiLink",
  "PAGE_TITLE_SETTINGS_SIGNIN": "Métodos de inicio de sesión · Ajustes · VehiLink",
  "PAGE_TITLE_SETTINGS_DEFAULT_HOME": "Página de inicio · Ajustes · VehiLink",
  "PAGE_TITLE_NOTIFICATIONS": "Notificaciones · VehiLink",
  "PAGE_TITLE_PROFILE": "Mi perfil · VehiLink",
  "PAGE_TITLE_PUBLIC_PROFILE": "Perfil · VehiLink",
  "PAGE_TITLE_SEARCH": "Buscar · VehiLink",
  "PAGE_TITLE_REPORT_AREA": "Reportar área · VehiLink",
  "PAGE_TITLE_HELP": "Ayuda · VehiLink"
}
